export default __webpack_public_path__ + "static/media/intro_banner_car.aec58770.png";